import styles from '@/components/Shares/Button.module.css';
import { Icons } from '@/components/Shares/Icons';
import { languages } from '@/i18n/i18n-config';
import { useLocale } from '@/i18n/useLocale';
import { ActionIcon, Image, Menu, Stack, Text } from '@mantine/core';
import { IconCheck } from '@tabler/icons-react';
import { useState } from 'react';
import classes from './LanguageButton.module.css';
export const LanguageButton = () => {
  const {
    locale
  } = useLocale();
  const [active, setActive] = useState(false);
  return <Menu shadow="md" width={256} withArrow arrowSize={15} transitionProps={{
    duration: 200,
    transition: 'fade-down'
  }} classNames={classes} radius={5} onChange={() => setActive(!active)} onClose={() => setActive(false)}>
      <Menu.Target>
        <ActionIcon size="input-md" classNames={{
        root: styles.btnIcon
      }} mod={{
        active: active
      }} onClick={() => setActive(!active)}>
          <Icons className="icon-pr-line-internet" fontSize={24} />
        </ActionIcon>
      </Menu.Target>

      <Menu.Dropdown bg="var(--navbar-bg-color)" pos="fixed" top={85}>
        <Stack gap={5} py={15} px={5}>
          {languages.map(item => <Menu.Item leftSection={<Image src={item.icon} radius="100%" alt={item.name} w={26} h={26} />} key={item.code} rightSection={locale === item.code ? <IconCheck color="var(--mantine-color-prime-0)" /> : null} mod={{
          active: locale === item.code
        }}>
              <Text fz={12} fw={700} tt="uppercase">
                {item.name}
              </Text>
            </Menu.Item>)}
        </Stack>
      </Menu.Dropdown>
    </Menu>;
};